<mat-sidenav-container>
  <mat-sidenav [ngClass]="headerChange ? 'header-height-thin': 'header-height'" #sideNavBar mode="over"
    [fixedInViewport]="true">
    <div class="main-div">
      <div class="sidenav-content">
        <mat-nav-list *ngFor="let menu of menuList" [ngClass]="{'enabled-menu': menu.isEnabled}">
          <mat-list-item (click)="navigateToLink(menu.route)" *ngIf="!menu.isDisabled">
            <div>
              <div class="align-center">
                <img [src]="menu.imagePath" class="image" alt="">
              </div>
              <p class="menu-title">{{menu.menuTitle}}</p>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>